import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-02-03
	search(params) {
		return axios.get('/logserver/sys-log?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-02-10
	findLast() {
		return axios.get('/logserver/sys-log/find-last');
	},


}